/**
 * CRO PDP — Livera Digest
 * Handles: variant switching, sticky ATC bar, upsell modal,
 *          live viewer counter, stock counter, buyers-today counter,
 *          image gallery, mid-page variant sync
 */

(function () {
  'use strict';

  // ─── Variant data ────────────────────────────────────────────────
  const VARIANTS = [
    { id: null, title: '1 + 1 Gratis',       days: 60,  perDay: '€0,67', total: null, compare: '79.98',  savings: null, upsellMsg: 'Krijg nu 30 dagen gratis! Voor maar €20 meer',   upsellSub: 'Upgrade naar het 1.5+1.5 pakket (90 dagen) en bespaar nog meer per dag.' },
    { id: null, title: '1.5 + 1.5 Gratis',   days: 90,  perDay: '€0,67', total: null, compare: '119.98', savings: null, upsellMsg: 'Krijg nu 30 dagen gratis! Voor maar €20 meer',   upsellSub: 'Upgrade naar het 2+2 pakket (120 dagen) en bespaar nog meer per dag.' },
    { id: null, title: '2 + 2 Gratis',        days: 120, perDay: '€0,67', total: null, compare: '159.98', savings: null, upsellMsg: 'Krijg nu 60 dagen gratis! Voor maar €40 meer',   upsellSub: 'Upgrade naar het 3+3 pakket (180 dagen) — ons beste aanbod.' },
    { id: null, title: '3 + 3 Gratis',        days: 180, perDay: '€0,67', total: null, compare: '239.98', savings: null, upsellMsg: null, upsellSub: null },
  ];

  let selectedVI = 1; // default: mid-tier
  let pendingVariantId = null;

  // ─── Init: read variant IDs and prices from the DOM ─────────────
  function initVariantData() {
    document.querySelectorAll('.cro-variant-radio').forEach((radio) => {
      const vi = parseInt(radio.dataset.vi, 10);
      if (!isNaN(vi) && VARIANTS[vi]) {
        VARIANTS[vi].id    = radio.value;
        VARIANTS[vi].total = radio.dataset.total;
        VARIANTS[vi].savings = radio.dataset.savings;
      }
    });
  }

  // ─── Variant selection ───────────────────────────────────────────
  function selectVariant(vi, source) {
    selectedVI = vi;
    const v = VARIANTS[vi];

    // Update all radio cards (main + mid)
    document.querySelectorAll('.cro-variant-card').forEach((card) => {
      const cardVi = parseInt(card.dataset.vi, 10);
      card.classList.toggle('is-selected', cardVi === vi);
    });
    document.querySelectorAll('.cro-variant-radio, .cro-variant-radio--mid').forEach((r) => {
      r.checked = parseInt(r.dataset.vi, 10) === vi;
    });

    // Update price block
    const perDayEl = document.getElementById('cro-per-day-display');
    const totalEl  = document.getElementById('cro-total-display');
    const compareEl = document.getElementById('cro-compare-display');
    if (perDayEl) perDayEl.childNodes[0].textContent = v.perDay;
    if (totalEl && v.total) totalEl.textContent = v.total;
    if (compareEl) compareEl.textContent = '€' + v.compare;
    const savingsAmountEl = document.getElementById('cro-savings-amount');
    if (savingsAmountEl && v.savings) {
      const savingsFormatted = parseFloat(v.savings).toFixed(2).replace('.', ',');
      savingsAmountEl.textContent = '€' + savingsFormatted;
    }

    // Update sticky bar
    const stickyPrice = document.getElementById('sticky-per-day');
    if (stickyPrice) stickyPrice.childNodes[0].textContent = v.perDay;
  }

  // ─── Variant card click ──────────────────────────────────────────
  function bindVariantCards() {
    document.querySelectorAll('.cro-variant-card').forEach((card) => {
      card.addEventListener('click', () => {
        const vi = parseInt(card.dataset.vi, 10);
        if (!isNaN(vi)) selectVariant(vi, 'card');
      });
    });
  }

  // ─── Add to cart (with upsell modal) ────────────────────────────
  function addToCart(variantId) {
    const form = document.getElementById('cro-product-form');
    if (!form) return;
    // Set the correct variant ID
    const radios = form.querySelectorAll('input[name="id"]');
    radios.forEach((r) => { r.checked = r.value === String(variantId); });
    // Submit
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(() => { window.location.href = '/cart'; })
      .catch(() => { window.location.href = '/cart'; });
  }

  function showUpsellModal(vi) {
    const v = VARIANTS[vi];
    const upsellVI = vi + 1;
    const upsellV  = VARIANTS[upsellVI];
    if (!upsellV || !v.upsellMsg) {
      // No upsell for top tier — add directly
      addToCart(v.id);
      return;
    }
    pendingVariantId = v.id;
    const modal = document.getElementById('cro-modal-backdrop');
    const offerEl = document.getElementById('cro-modal-offer');
    const subEl   = document.getElementById('cro-modal-sub');
    if (offerEl) offerEl.textContent = v.upsellMsg;
    if (subEl)   subEl.textContent   = v.upsellSub;
    // Store upsell variant ID on accept button
    const acceptBtn = document.getElementById('cro-modal-accept');
    if (acceptBtn) acceptBtn.dataset.upsellId = upsellV.id;
    if (modal) { modal.classList.add('is-open'); }
  }

  function bindATCButtons() {
    // Main ATC
    const mainAtc = document.getElementById('cro-atc-btn');
    if (mainAtc) {
      mainAtc.addEventListener('click', () => showUpsellModal(selectedVI));
    }
    // Sticky ATC
    const stickyAtc = document.getElementById('cro-sticky-atc-btn');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', () => showUpsellModal(selectedVI));
    }
    // Mid-page ATC
    const midAtc = document.getElementById('cro-mid-atc-btn');
    if (midAtc) {
      midAtc.addEventListener('click', () => showUpsellModal(selectedVI));
    }
  }

  function bindModal() {
    const backdrop = document.getElementById('cro-modal-backdrop');
    const closeBtn = document.getElementById('cro-modal-close');
    const acceptBtn = document.getElementById('cro-modal-accept');
    const declineBtn = document.getElementById('cro-modal-decline');

    function closeModal() {
      if (backdrop) { backdrop.classList.remove('is-open'); }
    }

    if (closeBtn)   closeBtn.addEventListener('click', closeModal);
    if (declineBtn) declineBtn.addEventListener('click', () => { closeModal(); addToCart(pendingVariantId); });
    if (acceptBtn)  acceptBtn.addEventListener('click', () => {
      const upsellId = acceptBtn.dataset.upsellId;
      closeModal();
      addToCart(upsellId || pendingVariantId);
    });
    // Backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', (e) => { if (e.target === backdrop) closeModal(); });
    }
    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && backdrop && !backdrop.hidden) closeModal();
    });
  }

  // ─── Sticky ATC bar (IntersectionObserver) ───────────────────────
  function initStickyBar() {
    const mainAtc = document.getElementById('cro-atc-btn');
    const stickyBar = document.getElementById('cro-sticky-bar');
    if (!mainAtc || !stickyBar) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entry.isIntersecting));
      },
      { threshold: 0.1 }
    );
    observer.observe(mainAtc);
  }

  // ─── Live viewer counter (fluctuates ±3 every 7s) ───────────────
  function initViewerCounter() {
    const el = document.getElementById('cro-viewers');
    if (!el) return;
    let count = 24;
    setInterval(() => {
      const delta = Math.floor(Math.random() * 7) - 3;
      count = Math.max(18, Math.min(31, count + delta));
      el.textContent = count;
    }, 7000);
  }

  // ─── Buyers today counter (fluctuates ±2 every 13s) ─────────────
  function initBuyersCounter() {
    const el = document.getElementById('cro-buyers-today');
    if (!el) return;
    let count = 47;
    setInterval(() => {
      const delta = Math.floor(Math.random() * 5) - 2;
      count = Math.max(38, Math.min(62, count + delta));
      el.textContent = count;
    }, 13000);
  }

  // ─── Stock counter (decrements slowly, stops at 8) ───────────────
  function initStockCounter() {
    const el = document.getElementById('cro-stock-count');
    if (!el) return;
    let stock = 14;
    // Decrement by 1 every 3–5 minutes
    function decrement() {
      if (stock > 8) {
        stock--;
        el.textContent = stock;
        const nextMs = (3 + Math.random() * 2) * 60 * 1000;
        setTimeout(decrement, nextMs);
      }
    }
    setTimeout(decrement, (3 + Math.random() * 2) * 60 * 1000);
  }

  // ─── Image gallery thumbnails ────────────────────────────────────
  function initGallery() {
    const mainImg = document.getElementById('cro-main-img');
    if (!mainImg) return;
    document.querySelectorAll('.cro-gallery__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.dataset.src;
        document.querySelectorAll('.cro-gallery__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // ─── Bootstrap ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initVariantData();
    bindVariantCards();
    bindATCButtons();
    bindModal();
    initStickyBar();
    initViewerCounter();
    initBuyersCounter();
    initStockCounter();
    initGallery();
    // Apply default selection
    selectVariant(1, 'init');
  });

})();
